import React, { ReactNode, useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TextField,
  Box,
} from "@mui/material";

type PendingPackagingItem = {
  id: string | number;
  itemName?: string;
  janCode?: string;
  expectedCount?: number;
  setCount?: number;

  deliveryCount?: number;
  amazonSetNum?: number;
};

type Props = {
  open: boolean;
  onClose: () => void;
  items: PendingPackagingItem[];
  imageUrl: string;
  handleUpdateStatus: () => void;
};

const JanCodeCheckDialog: React.FC<Props> = ({
  open,
  onClose,
  items,
  imageUrl,
  handleUpdateStatus,
}) => {
  // JAN確認欄の値を管理
  const [janConfirmValues, setJanConfirmValues] = useState<string[]>(
    items.map(() => "")
  );

  // 入力欄のrefを配列で管理
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

  // ダイアログオープン時に初期化 & 最初の入力欄にフォーカス
  useEffect(() => {
    console.log(items);
    if (open) {
      setJanConfirmValues(items.map(() => ""));
      setTimeout(() => {
        inputRefs.current[0]?.focus();
      }, 100);
    }
  }, [open, items]);

  // JAN確認欄の変更
  const handleJanConfirmChange = (index: number, value: string) => {
    const half = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    );
    // console.log(half);
    const updated = [...janConfirmValues];
    updated[index] = value;
    setJanConfirmValues(updated);
  };

  // 全て一致しているか判定
  const isAllMatched = items.every(
    (item, idx) => item.janCode === janConfirmValues[idx]
  );

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    const inputElement = e.target as HTMLInputElement; // ここでキャスト
    const halfWidthValue = inputElement.value.replace(
      /[Ａ-Ｚａ-ｚ０-９]/g,
      (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    );
    console.log(halfWidthValue);
    const numericValue = halfWidthValue.replace(/[^0-9]/g, "");

    if (inputRefs.current[index]) {
      inputRefs.current[index]!.value = numericValue;
    }
  };

  // Enter押下時に次の入力欄にフォーカス
  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (isAllMatched) {
        // handleUpdateStatus();
      } else {
        const nextIndex = index + 1;
        if (
          nextIndex < inputRefs.current.length &&
          inputRefs.current[nextIndex]
        ) {
          inputRefs.current[nextIndex]!.focus();
        }
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      disableEnforceFocus
      maxWidth={false}
      fullWidth={false}
      PaperProps={{
        sx: {
          display: "flex",
          width: "calc(100vw - 40px)",
          height: "calc(100vh - 40px)",
          maxWidth: "none",
          maxHeight: "none",
          overflowY: "auto",
        },
      }}
    >
      <DialogTitle>JANコード確認</DialogTitle>
      <DialogContent>
        <Box display="flex">
          {/* 写真部分 */}
          <Box
            sx={{
              width: "40%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRight: "1px solid #ccc",
              p: 2,
            }}
          >
            <img
              src={imageUrl}
              alt="商品画像"
              style={{
                width: 600,
                height: 600,
                objectFit: "contain",
              }}
            />
          </Box>

          {/* JAN確認テーブル */}
          <Box sx={{ width: "60%", p: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>商品名</TableCell>
                  <TableCell>セット数</TableCell>
                  <TableCell>納品数</TableCell>
                  <TableCell>JAN</TableCell>
                  <TableCell>JAN確認</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, idx) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.itemName}</TableCell>
                    <TableCell>{item.setCount}</TableCell>
                    <TableCell>{item.expectedCount}</TableCell>
                    <TableCell>{item.janCode}</TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        fullWidth
                        variant="outlined"
                        value={janConfirmValues[idx] || ""}
                        onChange={(e) =>
                          handleJanConfirmChange(idx, e.target.value)
                        }
                        // onChange={(e) => handleInputChange(e, idx)}
                        inputRef={(el) => (inputRefs.current[idx] = el)}
                        onKeyDown={(e) => handleKeyDown(e, idx)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <Typography variant="h5" mt={2}>
              セット数: {items[0]?.amazonSetNum ?? "ー"}　納品数:{" "}
              {items[0]?.deliveryCount ?? "ー"}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>閉じる</Button>
        <Button
          variant="contained"
          onClick={handleUpdateStatus}
          disabled={!isAllMatched}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default JanCodeCheckDialog;
